const Footer = () => {
  return (
    <footer className="metamuze-footer">
      <div className="container">
        <div className="footer-wrapp">
          <div className="row ">
            <div className="col-sm-3">
              <div className="d-flex align-items-center h-100 footer-logo-div">
                <img
                  className="logo-dark"
                  src="../../../assets/images/logo-dark-h.webp"
                  alt=""
                />
                <img
                  className="logo-light"
                  src="../../../assets/images/logo-light-h.webp"
                  alt=""
                />
              </div>
            </div>

            <div className="col-sm-5">
              <div className="d-flex justify-content-between all-nav-wrraper">
                <div className="footer-listone">
                  <h3 className="footer-title">Learn More</h3>
                  <ul className="footer-nav">
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="/">
                        Home
                      </a>
                    </li>
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="/ranking">
                        Ranking
                      </a>
                    </li>
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="/nftcollection">
                        Collections
                      </a>
                    </li>
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="#">
                        Physical Items
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-listtwo">
                  <h3 className="footer-title">Marketplace</h3>
                  <ul className="footer-nav">
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="#">
                        Auctions
                      </a>
                    </li>
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="#">
                        Raffles
                      </a>
                    </li>
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="#">
                        Buy/Sell
                      </a>
                    </li>
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="#">
                        NFT Staking
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-listhree">
                  <h3 className="footer-title quick-links">Quick Links</h3>
                  <ul className="footer-nav">
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="#">
                        Whitepaper
                      </a>
                    </li>
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="#">
                        Pitch Deck
                      </a>
                    </li>
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="#">
                        Marketplace
                      </a>
                    </li>
                    <li className="footer-nav-li">
                      <a className="footer-nav-a" href="#">
                        Smart contract
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-sm-4 subcribe-col">
              <h3 className="footer-title text-end subscribe-us">
                Subscribe Us
              </h3>
              <div className="d-flex">
                <input
                  type="text"
                  className="subscribe-input"
                  placeholder="info@mail.com"
                />
                <img
                  className="footer-newsletter"
                  src="../../../assets/images/newsletter.png"
                  alt=""
                />
              </div>

              <div className="social-icons">
                <img
                  className="footer-social-item"
                  src="../../../assets/images/social/fb.png"
                  alt=""
                />
                <img
                  className="footer-social-item"
                  src="../../../assets/images/social/insta.png"
                  alt=""
                />
                <img
                  className="footer-social-item"
                  src="../../../assets/images/social/discord.png"
                  alt=""
                />
                <img
                  className="footer-social-item"
                  src="../../../assets/images/social/twitter.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
